import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueMq from 'vue-mq';
import Vuelidate from 'vuelidate';

import  Lang from 'lang.js';
import translations from './jsTranslations.js';

var lang = new Lang();

lang.setMessages(translations);
Vue.filter('trans', (...args) => {
	return lang.get(...args);
});


window.lang = lang;
window.Vue = Vue;
Vue.use(VueRouter);

//lang.setLocale('de'); // todo need to implement in correct place

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
window.axios.defaults.baseURL = '/ajax';

//media queries
Vue.use(VueMq, {
    breakpoints: {
        sm: 1179,
        lg: 1180
    }
});

//Form validation
Vue.use(Vuelidate);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
